import { render } from "./StyrianerWerden.vue?vue&type=template&id=12ca61c8"
import script from "./StyrianerWerden.vue?vue&type=script&lang=ts"
export * from "./StyrianerWerden.vue?vue&type=script&lang=ts"

import "./StyrianerWerden.vue?vue&type=style&index=0&id=12ca61c8&lang=scss"
script.render = render

export default script